import { render, staticRenderFns } from "./ScreenshotsCarouselComponent.vue?vue&type=template&id=192c47c0"
import script from "./ScreenshotsCarouselComponent.vue?vue&type=script&lang=ts"
export * from "./ScreenshotsCarouselComponent.vue?vue&type=script&lang=ts"
import style0 from "./ScreenshotsCarouselComponent.vue?vue&type=style&index=0&id=192c47c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports